import React from 'react'
import Box from '@mui/material/Box'
import { HtmlText } from '../components/HtmlText'

const ThankingCommunity = () => {
  return (
    <Box>
      <HtmlText name={'thankCommunity'} />
    </Box>
  )
}

export default ThankingCommunity
